import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectCustomerData } from "../../redux/slices/customerSlice";
import { MdOutlineClose } from "react-icons/md";
import { FiChevronRight } from "react-icons/fi";
import _ from "lodash"; // Import lodash for deep cloning
import {
  useApplyCouponMutation,
  useCalculateBillingRateMutation,
  useSaveAuditLogMutation,
} from "../../redux/services/calculateBillingRateService";
import { getCustomerId, selectJwtToken } from "../../redux/slices/authSlice";
import {
  formatDateTime,
  getAmount,
  normalizeInput,
  roundNumber,
} from "../../redux/services/utility";
import ApplyPromoCode from "../FindParkingSlot/ApplyPromoCode";
import RegularModal from "../../components/Modals/RegularModal";
import { Checkbox, Dialog, Modal } from "@mui/material";
import { useAppSelector } from "../../redux/app/hooks";
import * as Yup from "yup";
import { REGEX_CONSTANT } from "../../../src/environment/AppConstants";
import { Formik, Form, Field } from "formik";
import { useFindByCustomerIdMutation } from "../../redux/services/cartApi";
import { getUserData } from "../../redux/slices/authSlice";
import {
  useCreateOrderMutation,
  useCreateOrderRazorpayMutation,
  usePaymentWithCheckoutPageMutation,
} from "../../redux/services/stripeApi";
import GuestLoggIn from "../../auth/pages/GuestLoggIn";
import RegularButton from "../../components/Buttons/RegularButton";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import GuestSignUp from "../../auth/pages/GuestSignUp";
import Loading from "../commons/Loading";
import {
  getClientSecret,
  resetPaymentDetail,
  setPaymentDetail,
} from "../../redux/slices/stripeSlice";
import format from "date-fns/format";
import { useSaveBookingDetailMutation } from "../../redux/services/bookingApi";
import { getCartData } from "../../redux/slices/cartSlice";
import Header from "../../components/Header/Header";
import { useExportToPDFMutation } from "../../redux/services/qrCodePdfDownloadApi";
import toast from "react-hot-toast";
import PaymentMethod from "./PaymentMethod";
import { setCashFreePaymentDetail } from "../../redux/slices/cashFreeSlice";
import MuiAlert from "../MuiAlert/MuiAlert";
import { getTypeName } from "../../redux/slices/navSlice";
import BookingSummary from "./BookingSummary";
import PaymentSummary from "./PaymentSummary";
import { CustomizedSteppers } from "../../components/StatusBar/CustomStepLabel";

type Props = {};

const SignInSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  mobileNumber: Yup.string()
    .required("Mobile Number is required")
    .matches(new RegExp(REGEX_CONSTANT.ONLY_NUMBER), "Only Numbers allowed")
    .min(10, "Minimum 10 digits")
    .max(15, "Maximum 10 digits"),
});

const Payment = (props: Props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data: any = location.state;
  const userData = useSelector(getUserData);
  const customerId = useSelector(getCustomerId);
  const clientSecret = useSelector(getClientSecret);
  const cartData: any = useAppSelector(getCartData);
  console.log(cartData, "cartData");
  const [showOffer, setShowOffer] = useState(false);
  const [code, setCode] = useState("");
  const [offerDetail, setOfferDetail] = useState() as any;
  const [booking, setBooking] = useState(false);
  const [bookingDetail, setBookingDetail] = useState() as any;
  console.log(bookingDetail, "bookingDetail");
  const [parkingDetail, setParkingDetail] = useState() as any;
  console.log(parkingDetail, "parkingDetail");
  const [parkingSpaceName, setParkingSpaceName] = useState() as any;
  const customerData = useSelector(selectCustomerData) as any;
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const [findByCustomerId, customerIdResponse] = useFindByCustomerIdMutation();
  const [cartDataDetails, setCartDataDetails] = useState() as any;
  const [isLoggedIn, setIsLoggedIn] = useState() as any;
  const [checkoutGuest, setCheckoutGuest] = useState(false);
  const [loginScreen, setLoginScreen] = useState(true);
  const [redeemChecked, setRedeemChecked] = useState(false);
  const [calculateBillingRate, billingRateResponse] =
    useCalculateBillingRateMutation();
  const [saveBookingDetail, saveBookingDetailResponse] =
    useSaveBookingDetailMutation();
  const [bookingPayload, setBookingPayload] = useState({});
  const [auditLog, auditLogResponse] = useSaveAuditLogMutation();
  const [cashbackSucess, setCashbackSuccess] = React.useState(false);
  const [qrCodePDFDownload, qrCodePDFDownloadResponse] =
    useExportToPDFMutation();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const getTypeNameValue = useAppSelector(getTypeName);

  const cartId: any =
    localStorage.getItem("cartId") !== "null"
      ? localStorage.getItem("cartId")
      : null;


  useEffect(() => {
    if (cartData) {
      if (
        cartData[0]?.bookingDetail === undefined ||
        cartData[0]?.bookingDetail === null
      ) {
        navigate("/");
      }
      console.log(cartData[0], "cartData")
      setBookingDetail(cartData[0]?.bookingDetail);
      setParkingDetail(cartData[0]?.parkingDetail);
      setBooking(cartData[0]?.bookingDetail?.booking);
      setParkingSpaceName(cartData[0]?.bookingDetail?.parkingSpaceName);

    }
  }, [cartData]);



  useEffect(() => {
    const paymentIntentClientCecret = new URLSearchParams(
      window.location.search
    ).get("payment_intent_client_secret");
    if (paymentIntentClientCecret) {
      setCheckoutGuest(true);
    }
  }, []);

  const guestLoginResponse = (value: boolean) => {
    setIsLoggedIn(value);
  };

  const getIsLoggedIn = () => {
    let isLoggedIn: any = localStorage.getItem("isLoggedIn");
    isLoggedIn = JSON.parse(isLoggedIn);
    setIsLoggedIn(isLoggedIn);
  };

  useEffect(() => {
    getIsLoggedIn();
  }, [isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      findByCustomerId({
        token: token,
        id: userData?.customerId,
      });
    }
  }, []);

  useEffect(() => {
    if (customerIdResponse.isSuccess) {
      setCartDataDetails(customerIdResponse.data);
    }
    if (customerIdResponse.isError) {
      console.error("Fetch customer cart error", customerIdResponse);
    }
  }, [customerIdResponse.isSuccess || customerIdResponse.isError]);

  useEffect(() => {
    let idxLastWhitespace =
      parkingSpaceName && parkingSpaceName.lastIndexOf(" ");
    const code =
      parkingSpaceName &&
      parkingSpaceName.substring(0, 1) +
      parkingSpaceName.substring(
        idxLastWhitespace + 1,
        idxLastWhitespace + 2
      ) +
      "-";
    setCode(code);
  }, [booking]);

  const appliedCoupon = (flag: boolean, offerDetail: any) => {
    console.log(new Date(bookingDetail?.bookingDetail?.checkinTime), new Date(bookingDetail?.bookingDetail?.checkoutTime), "checkout");
    let payload = {
      checkInTime: format(new Date(bookingDetail?.payload?.checkinTime), "yyyy-MM-dd HH:mm:ss"),
      checkOutTime: format(new Date(bookingDetail?.payload?.checkoutTime), "yyyy-MM-dd HH:mm:ss"),
      parkingCategoryId: bookingDetail?.payload?.parkingCategoryId,
      parkingSpaceLocationId: bookingDetail?.payload?.parkingLocationId,
      offerId: offerDetail === "REMOVE" ? "" : offerDetail.id,
      parkingType: bookingDetail?.payload.serviceType,
      fromLat: bookingDetail?.payload?.fromLatitude,
      fromLng: bookingDetail?.payload?.fromLongitude,
      toLat: bookingDetail?.payload?.toLatitude,
      toLng: bookingDetail?.payload?.toLongitude,
      customerId: userData?.customerId,
      duration: bookingDetail?.payload?.serviceType === 'Hourly Rental' ? bookingDetail?.payload?.duration : null,
      distance: bookingDetail?.payload?.serviceType === 'Hourly Rental' ? bookingDetail?.payload?.distance : null,
      tollReqDTO: {
        from: {
          address: bookingDetail?.payload?.fromLocation,
        },
        serviceProvider: "here",
        to: {
          address: bookingDetail?.payload?.toLocation,
        },
      },
    };

    calculateBillingRate({
      payload: payload,
    });

    setBookingPayload(payload);
    setShowOffer(flag);
    setOfferDetail(offerDetail);
  };

  useEffect(() => {
    if (billingRateResponse.isSuccess) {
      console.log(bookingDetail, "bookingDetail");

      let bookingDetails = _.cloneDeep(bookingDetail);
      bookingDetails.payload = {
        ...bookingDetails.payload,
        ammount:
          billingRateResponse.data?.discountedAmount != null
            ? roundNumber(billingRateResponse.data?.discountedAmount)
            : roundNumber(billingRateResponse.data?.totalAmount),
        discount:
          billingRateResponse.data?.discount !== null
            ? roundNumber(billingRateResponse.data?.discount)
            : 0,
        discountType: billingRateResponse.data?.discountType,
        totalTaxAmount:
          billingRateResponse.data?.totalTaxAmount !== null
            ? roundNumber(billingRateResponse.data?.totalTaxAmount)
            : 0,
        salesTaxAmount:
          billingRateResponse.data?.salesTaxAmount !== null
            ? roundNumber(billingRateResponse.data?.salesTaxAmount)
            : 0,
        salesTaxRate:
          billingRateResponse.data?.salesTaxRate !== null
            ? roundNumber(billingRateResponse.data?.salesTaxRate)
            : 0,
        stateTaxRate:
          billingRateResponse.data?.stateTaxRate !== null
            ? roundNumber(billingRateResponse.data?.stateTaxRate)
            : 0,
        stateTaxAmount:
          billingRateResponse.data?.stateTaxAmount !== null
            ? roundNumber(billingRateResponse.data?.stateTaxAmount)
            : 0,
        countyTaxRate:
          billingRateResponse.data?.countyTaxRate !== null
            ? roundNumber(billingRateResponse.data?.countyTaxRate)
            : 0,
        countyTaxAmount:
          billingRateResponse.data?.countyTaxAmount !== null
            ? roundNumber(billingRateResponse.data?.countyTaxAmount)
            : 0,
        fixedFee:
          billingRateResponse.data?.fixedFee !== null
            ? roundNumber(billingRateResponse.data?.fixedFee)
            : 0,
        offerDetailId: billingRateResponse.data?.offerId,
        offerDiscount:
          billingRateResponse.data?.offerDiscount !== null
            ? roundNumber(billingRateResponse.data?.offerDiscount)
            : 0,
        offerType: billingRateResponse.data?.offerType,
        totalAmount:
          billingRateResponse.data?.totalAmount !== null
            ? roundNumber(billingRateResponse.data?.totalAmount)
            : 0,
        finalAmount:
          (billingRateResponse.data?.discountedAmount != null
            ? roundNumber(billingRateResponse.data?.discountedAmount)
            : roundNumber(billingRateResponse.data?.totalAmount)) +
          (billingRateResponse.data?.totalTaxAmount !== null
            ? roundNumber(billingRateResponse.data?.totalTaxAmount)
            : 0) +
          (bookingDetails.payload?.convenienceFee || 0),
        totalBookingAmount:
          (billingRateResponse.data?.discountedAmount != null
            ? roundNumber(billingRateResponse.data?.discountedAmount)
            : roundNumber(billingRateResponse.data?.totalAmount)) +
          (billingRateResponse.data?.totalTaxAmount !== null
            ? roundNumber(billingRateResponse.data?.totalTaxAmount)
            : 0) +
          (bookingDetails.payload?.convenienceFee || 0),
        taxAmount:
          billingRateResponse.data?.totalTaxAmount !== null
            ? roundNumber(billingRateResponse.data?.totalTaxAmount)
            : 0,
      };

      setBookingDetail(bookingDetails);

      auditLog({
        payload: {
          cartId: cartId,
          endTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
          eventName: "WEB",
          request: JSON.stringify(bookingPayload),
          response: JSON.stringify(billingRateResponse),
          serviceName: "NEW_BOOKING",
          startTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
          url: "/bookingDetail/save",
        },
      });
    }

    if (billingRateResponse.isError) {
      console.error(billingRateResponse.error, "<==error");
      let errorMessage = "An error occurred.";

      if (billingRateResponse.error && "data" in billingRateResponse.error && billingRateResponse.error.data?.serviceErrors) {
        errorMessage = billingRateResponse.error.data.serviceErrors[0]?.msg || errorMessage;
      }

      message(errorMessage);
    }
  }, [billingRateResponse.isSuccess, billingRateResponse.isError]);



  const closeModal = (event: any) => {
    event.stopPropagation();
    setShowOffer(false);
  };

  const handleLogin = (values: any) => { };

  const handleDownloadQRcode = (saveBookingDetailResponse: any) => {
    qrCodePDFDownload({
      token: token,
      bookingId: saveBookingDetailResponse.data[0].id,
      bookingCode: saveBookingDetailResponse.data[0].bookingCode,
      flag: "CHECKINCHECKOUT",
    });
  };

  useEffect(() => {
    if (qrCodePDFDownloadResponse.isSuccess) {
      console.log("qrCodePDFDownloadResponse ", qrCodePDFDownloadResponse);
      const url = window.URL.createObjectURL(new Blob([qrCodePDFDownloadResponse.data]));
      const link: any = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${formatDateTime(new Date(), "MM/DD/yyyy, hh:mm A")}, ${qrCodePDFDownloadResponse?.originalArgs?.bookingCode}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  }, [qrCodePDFDownloadResponse.isSuccess]);


  const customerDetails = useAppSelector(selectCustomerData);
  const guestUserData: any =
    localStorage.getItem("guestData") !== "null"
      ? localStorage.getItem("guestData")
      : {};



  useEffect(() => {
    if (saveBookingDetailResponse.isSuccess) {
      localStorage.removeItem("bookingDetail");
      setCashbackSuccess(true);
      auditLog({
        payload: {
          cartId: cartId,
          endTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
          eventName: "WEB",
          request: JSON.stringify(bookingPayload),
          response: JSON.stringify(saveBookingDetailResponse),
          serviceName: "NEW_BOOKING",
          startTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
          url: "/bookingDetail/save",
        },
      });
    }
    if (saveBookingDetailResponse.isError) {
      setCashbackSuccess(false);
    }
  }, [saveBookingDetailResponse.isSuccess, saveBookingDetailResponse.isError]);


  let message = (msg: any) => {
    console.log(msg, "msg");
    setStatusCode({
      type: "error",
      code: msg,
    });
    setIsAlertVisible(true);
    setTimeout(() => {
      setIsAlertVisible(false);
    }, 5000);
  };

  return (
    <div>
      <div className="h-[75px] z-10 fixed md:mx-10 mx-2">
        <Header position={"fixed"} isLoggedIn={token ? true : false} />
      </div>
      <Box className="lg:p-[4] md:px-[5%] px-1 ">
        <CustomizedSteppers activeStep={2} />
        <p className="md:text-[30px] ml-6 text-[18px] text-gray-600 text-start font-semibold">   {booking ? "Booking" : "Payment"}</p>
        {isAlertVisible && (
          <div>
            <MuiAlert
              severity={statusCode?.type!}
              messageType={statusCode?.code!}
            />
          </div>
        )}
        <div className="md:flex">
          <div className=" md:w-1/2">
            <div className="items-center md:flex-row md:justify-center w-full">
              <div className="text-xl mt-6   w-full p-4">
                <div
                  className={` bg-[#F9F4EF] mb-3 p-3 h-fit rounded-full shadow-md ${isLoggedIn == false ? "cursor-pointer" : "cursor-auto"}`}
                >
                  <div
                    onClick={() => {
                      if (isLoggedIn == false) {
                        setCheckoutGuest(false);
                      }
                    }}
                    className="m-2 flex items-center"
                  >
                    <img
                      className="w-[18px] h-auto"
                      src={require("../../assets/Profile@2x.png")}
                    />
                    <p className="text-sm md:ml-5 ml-2">
                      {isLoggedIn
                        ? `${userData?.name} | ${userData?.email}`
                        : "Sign in to book your car rental!"}
                    </p>
                  </div>
                </div>

                {!isLoggedIn &&
                  // booking &&
                  checkoutGuest === false &&
                  loginScreen && (
                    <div className="bg-[#F9F4EF] mb-3 p-3 h-fit rounded-xl shadow-md">
                      <GuestLoggIn guestLoginResponse={guestLoginResponse} />
                      <div>
                        <p className="mb-0 text-sm text-center text-gray-500 mt-4 cursor-default ">
                          Don't have an account yet?{" "}
                          <span
                            className="text-blue-500 text-sm cursor-pointer"
                            onClick={() => {
                              setLoginScreen(false);
                            }}
                          >
                            Sign up
                          </span>
                        </p>
                      </div>
                    </div>
                  )}
                {!isLoggedIn &&
                  // booking &&
                  checkoutGuest === false &&
                  loginScreen === false &&
                  (
                    <div className="bg-[#F9F4EF] mb-3 p-3 h-fit rounded-xl shadow-md">
                      <GuestSignUp guestLoginResponse={guestLoginResponse} />
                      <div>
                        <p className="mb-0 text-center text-sm text-gray-500 py-6 cursor-default ">
                          Already have an account?{" "}
                          <span
                            className="text-blue-500 text-sm cursor-pointer"
                            onClick={() => {
                              setLoginScreen(true);
                            }}
                          >
                            Sign in
                          </span>
                        </p>
                      </div>
                    </div>
                  )}
                <div className=" mx-auto w-full">
                  {cartDataDetails === null && (
                    <div>
                      <p>
                        Oops... You don't have any booking in your cart.
                        Please add to make your booking.
                      </p>
                    </div>
                  )}
                  <div className="flex justify-between items-center flex-row">
                    <div className="">
                      <label
                        className={`flex justify-center gap-2 py-3 px-4 cursor-pointer rounded-full transition-all text-center lg:w-56 md:w-40 w-32  bg-[#ED1C24] text-white shadow-md`}
                      >
                        {/* <img src={option.imageUrl} className="h-6 w-6" alt="icon" /> */}
                        <span className="text-sm font-semibold">{bookingDetail?.payload?.serviceType}</span>
                      </label>
                    </div>
                    {isLoggedIn &&
                      (
                        <div
                          className="flex justify-end  p-3 rounded-lg text-lg h-[60px] "
                          style={{
                            backgroundImage: `url(${require('../../assets/Offer.png')})`, // Your ticket-shaped background
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                            setShowOffer(true);
                          }}
                        >
                          <div className="flex flex-row justify-center w-full cursor-pointer">
                            <div className="flex items-center mr-auto ml-4">

                              <p className=" text-white text-sm font-semibold">Apply Offers</p> {/* Adjust text color if needed */}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                {bookingDetail && (
                  <div className="mt-3">
                    <BookingSummary
                      parkingSpaceName={parkingSpaceName}
                      bookingDetail={bookingDetail}
                      isBooking={booking}
                      isLoggedIn={isLoggedIn}
                      customerData={customerData}
                      parkingDetail={parkingDetail}
                      isRedeem={redeemChecked}
                    />
                  </div>
                )}
                {redeemChecked && bookingDetail.isFullCashback && (
                  <div className="w-full">
                    <RegularButton className="w-full" title={"Book Now"} />
                  </div>
                )}
                {showOffer && (
                  <RegularModal
                    modalDialogStyle={"lg:w-1/2 md:w-9/12 w-full"}
                    children={
                      <ApplyPromoCode
                        route={{
                          parkingLocationId: bookingDetail.parkingLocationId,
                        }}
                        amount={bookingDetail.totalAmount}
                        appliedOffer={offerDetail}
                        couponApply={appliedCoupon}
                        closeModal={closeModal}
                        parkingLocationId={bookingDetail.parkingLocationId}
                      />
                    }
                  />
                )}
              </div>
            </div>
          </div>
          <div className="mx-4 md:mx-0 md:w-1/2  ">
            {bookingDetail && (
              <div className="md:mt-10 mt-3">
                <PaymentSummary
                  parkingSpaceName={parkingSpaceName}
                  bookingDetail={bookingDetail}
                  isBooking={booking}
                  isLoggedIn={isLoggedIn}
                  customerData={customerData}
                  parkingDetail={parkingDetail}
                  isRedeem={redeemChecked}
                />
              </div>
            )}
            {isLoggedIn &&
              // booking &&
              (
                <div className="bg-[#F9F4EF] p-3 h-fit rounded-xl shadow-md mt-3">
                  <PaymentMethod
                    bookingDetail={bookingDetail}
                    parkingDetail={parkingDetail}
                    message={message}
                  />
                </div>

              )}
          </div>
        </div>
        {customerIdResponse.isLoading ? (
          <Loading />
        ) : null}
        {cashbackSucess && (
          <RegularModal
            modalDialogStyle="w-[600px] h-[535px] rounded-none"
            visible={cashbackSucess}
            setVisible={setCashbackSuccess}
          >
            <div>
              <div className="bg-blue-600 text-white gap-0 p-10">
                <div className="text-center justify-center items-center flex-col pb-4">
                  <h1 className="font-bold text-gray-200 text-2xl">Congratulations!</h1>
                  <h4 className="font-medium text-gray-200 text-lg">
                    You have reserved your
                  </h4>
                  <h5 className="font-medium text-gray-200 text-lg">spot Successfully!!!</h5>
                </div>
                <div className="text-center text-gray-200 justify-center items-center flex-col text-white">
                  <h4 className="font-medium text-gray-200 text-xl">Booking details: </h4>
                </div>
                <div className="text-[15px] lg:text-[20px] ">
                  <div className="flex justify-center ml-[6px] pb-2">
                    <img
                      className="h-auto cursor-pointer rounded-2xl"
                      src={
                        "data:image/png;base64," + saveBookingDetailResponse &&
                        saveBookingDetailResponse.data &&
                        saveBookingDetailResponse.data[0].qrImage
                      }
                      style={{ objectPosition: "center" }}
                      alt="QR Code for booking"
                      width={"150px"}
                      height={"150px"}
                    />
                  </div>
                  <div className="flex justify-center text-gray-200 text-xs md:text-base">
                    <p className="text-gray-200">Unique ID : </p>
                    <p className="ml-4 text-gray-200">
                      {saveBookingDetailResponse &&
                        saveBookingDetailResponse.data &&
                        saveBookingDetailResponse.data[0]?.bookingCode}
                    </p>
                  </div>
                  <div className="flex text-gray-200  justify-center text-xs md:text-base">
                    <p className="text-gray-200">Check-In Time : </p>
                    <p className="ml-4 text-gray-200">
                      {saveBookingDetailResponse &&
                        saveBookingDetailResponse.data &&
                        saveBookingDetailResponse.data &&
                        formatDateTime(
                          saveBookingDetailResponse &&
                          saveBookingDetailResponse.data &&
                          saveBookingDetailResponse.data[0]?.checkinTime,
                          "MM/DD/YYYY hh:mm A"
                        )}
                    </p>
                  </div>
                  <div className="flex text-gray-200 justify-center text-xs md:text-base">
                    <p className="text-gray-200">Check-Out Time : </p>
                    <p className="ml-4 text-gray-200">
                      {saveBookingDetailResponse &&
                        saveBookingDetailResponse.data &&
                        saveBookingDetailResponse.data &&
                        formatDateTime(
                          saveBookingDetailResponse &&
                          saveBookingDetailResponse.data &&
                          saveBookingDetailResponse.data[0]?.checkoutTime,
                          "MM/DD/YYYY hh:mm A"
                        )}
                    </p>
                  </div>
                </div>
                <div className=" flex flex-col justify-evenly mt-4 md:flex-row">
                  <RegularButton
                    onClick={() => {
                      navigate("/");
                    }}
                    className=" w-1/2 md:w-full p-2 bg-white text-sky-500 hover:bg-slate-100"
                    title={"Done! Go home"}
                  />
                  <RegularButton
                    onClick={() =>
                      handleDownloadQRcode(saveBookingDetailResponse)
                    }
                    className="w-1/2 md:w-full p-2 bg-white text-sky-500 hover:bg-slate-100 md:mt-0 mt-2"
                    title={" Download QR Code"}
                  />
                </div>
              </div>
            </div>
          </RegularModal>
        )}
      </Box>
      <div>
        <img
          className="w-full mt-2 h-auto"
          src={require("../../assets/Bottom banner@2x.png")}
        />
        <div className="bg-[#ED1C24] h-[50px] mt-4"></div>

      </div>
    </div>
  );
};

export default Payment;
